import client from "../api/client";

const localFallback = (prefix) => {
  const d = new Date();
  const ymd = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}`;
  const key = `voucher_seq_${prefix}_${ymd}`;
  const next = Number(localStorage.getItem(key) || "0") + 1;
  localStorage.setItem(key, String(next));
  return `${prefix}-${ymd}-${String(next).padStart(4, "0")}`;
};

export async function getNextVoucherNo(kind, voucherDate) {
  const prefixMap = {
    receipt: "RCPT",
    payment: "PAY",
    sales: "SAL",
    purchase: "PUR",
    "credit-note": "CN",
    "debit-note": "DN",
    contra: "CON",
    gst: "GST",
    journal: "JV",
    opening: "OB",
    invoice: "INV",
    stock: "STK",
    customer: "CUST",
    supplier: "SUP",
  };
  const prefix = prefixMap[kind] || "JV";
  try {
    const companyId = Number(localStorage.getItem("companyId") || 0) || undefined;
    const res = await client.get("/vouchers/next-number", {
      params: { kind, companyId, date: voucherDate },
      skipGlobalLoading: true,
    });
    return res.data?.voucherNo || localFallback(prefix);
  } catch (e) {
    console.warn("Voucher number API failed; using local fallback", e);
    return localFallback(prefix);
  }
}
